"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerAccountsBase = exports.listAssessmentTemplates = exports.SnapshotsSubQuery = void 0;
var SnapshotsSubQuery;
(function (SnapshotsSubQuery) {
    SnapshotsSubQuery[SnapshotsSubQuery["METADATA_ONLY"] = 0] = "METADATA_ONLY";
    SnapshotsSubQuery[SnapshotsSubQuery["METADATA_AND_CONTENT"] = 1] = "METADATA_AND_CONTENT";
})(SnapshotsSubQuery = exports.SnapshotsSubQuery || (exports.SnapshotsSubQuery = {}));
exports.listAssessmentTemplates = `
  query GetAssessmentTemplates(
    $filter: AssessmentTemplateFilter
    $limit: Int
    $nextToken: AWSJSON
  ) {
    getAssessmentTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        title
        applicationTitle
        description
        type
        version
        lastUpdated
        locale
        deliveryGuidance {
          description
          learnMore
        }
        applicability {
          prompts {
            id
            label {
              label
              text
            }
            context {
              label
              text
            }
            hint {
              label
              text
            }
            responseType
            responseSelections {
              selectionDescription
              selections {
                selectionLabel
                selectionId
              }
            }
          }
        }
        metadataConfig {
          excludeOptionalMetadataKeys
          requiredMetadataKeys
          customMetadata {
            key
            keyName
            keyDescription
            valueType
            valueHint
            defaultValue
            responseSelections {
              selectionDescription
              selections {
                selectionLabel
                selectionId
              }
            }
          }
        }
      }
      nextToken
    }
  }
`;
exports.getCustomerAccountsBase = `
  query GetCustomerAccounts(
    $filter: CustomerAccountFilter!
    $limit: Int
    $nextToken: AWSJSON
  ) {
    getCustomerAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        organizationId
        referenceId
        accountName
        ownerId
        createdBy
        updatedBy
        website
        industry
        region
        territory
        geo
        segment
        contacts {
          lastName
          firstName
          email
          title
        }
      }
      nextToken
    }
  }
`;
